import React, { useContext, useEffect, useRef, useState } from "react";
// import greetingCard from "../../assets/header-icons/sec_header_greeting.svg";
import logo from "../../assets/header-icons/indexx-logo-v3-dark.svg";
import "./style.css";
import CrossIcon from "../../assets/header-icons/cross";
import CrossIconNew from "../../assets/homepage/updated/cross_white.png";
import DarkMode from "../DarkMode/DarkMode";
import { Theme } from "../../utils/themeContext";
import frame from "../../assets/updated/header/captain.png";
import beeframe from "../../assets/updated/header/normal.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import dummy from "../../assets/updated/dummy.png";
import zodiacLogo from "../../assets/updated/homePage/zodiacLogo.png";
import ProductLauncher from "../ProductLauncher";
// import Fantasy_Lotto from '../../assets/BSheader/fantasy.png';
// import token from '../../assets/BSheader/tokens icon 1.svg';
// import token_white from '../../assets/BSheader/tokens icon  white (1).svg';
import Data, { auth_header_data, updateAuthHeaderData } from "./data";
import { useMediaQuery } from "@mui/material";
import {
  getCaptainBeeStatics,
  getHoneyUserDetails,
  getCaptainBeeByEmail,
  checkByemail,
} from "../../services/api";
const EXTERNAL_DOMAINS = [
  "https://bitcoinyay.com",
  "https://eenymeenyminymoe.io",
  "http://jackai.si",
  "https://wallstreet.indexx.ai",
  "https://lotto.indexx.ai",
  "https://cex.indexx.ai",
  "https://academy.indexx.ai",
  "https://shop.indexx.ai",
  "https://whoisbitcoinsatoshi.wtf",
];

const getSignedUrl = (url: string): string => {
  const accessToken = localStorage.getItem("access_token");
  const shortToken = localStorage.getItem("shortToken");
  if (!accessToken || !shortToken) return url;
  if (!EXTERNAL_DOMAINS.some((d) => url.startsWith(d))) return url;
  const urlObj = new URL(url);
  urlObj.searchParams.set("signInToken", shortToken);
  return urlObj.toString();
};

const HeaderTest: React.FC = () => {
  const { pathname } = useLocation();
  const themeData = useContext(Theme);
  const timeoutRef = useRef<any>(null);
  const elementRef = useRef(null);
  const [headerData, setHeaderData] = useState(Data);
  const [authHeader, setAuthHeader] = useState(auth_header_data);
  const [backdropVisibility, setBackdropVisibility] = useState(false);
  const [theme, setTheme] = useState<any>(themeData?.theme ?? "dark");
  const [activeIndex, setactiveIndex] = useState(0);
  const isMobile = useMediaQuery("(max-width:1310px)");
  const isAuthenticated = localStorage.getItem("access_token") !== null;

  const [isCaptain, setisCaptain] = useState(false);
  const [loading, setLoading] = useState(true);

  const [userProfile, setUserProfile] = useState();
  const [profileLoading, setProfileLoading] = useState(true);
  const userEmail =
    localStorage.getItem("user") || localStorage.getItem("email") || "";

  const navigate = useNavigate();
  useEffect(() => {
    if (themeData?.theme) {
      setTheme(themeData?.theme);
    }
  }, [themeData?.theme]);

  // useEffect(() => {
  //   updateAuthHeaderData(authHeader).then((data) => console.log(data));
  // }, [isAuthenticated]);

  useEffect(() => {
    setAuthHeader(
      authHeader.map((el) => {
        if (pathname.includes("/how-master-login-works")) {
          if (el.mainTextDesktop === "How it Works") {
            return { ...el, active: true };
          }
        } else if (pathname.includes("/auth/login")) {
          if (el.mainTextDesktop === "Login") {
            return { ...el, active: true };
          }
        } else if (pathname.includes("/auth/signup-email")) {
          if (el.mainTextDesktop === "Register") {
            return { ...el, active: true };
          }
        }
        // In all other cases, set 'active' to false
        return { ...el, active: false };
      })
    );
  }, [pathname]);

  const handleExternalLink = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string
  ) => {
    const signed = getSignedUrl(href);
    if (signed !== href) {
      e.preventDefault();
      window.location.href = signed;
    }
  };

  const handleItemClick = (path: string, i: number) => {
    setactiveIndex(i);
    window.location.href = getSignedUrl(path);
  };
  const handleMouseEnter = () => {
    // Set a timeout to open the dropdown after 0.2s
    timeoutRef.current = setTimeout(() => {
      setBackdropVisibility(true);
    }, 200);
  };

  const handleMouseLeave = () => {
    // Clear the timeout if user leaves before 0.2s
    clearTimeout(timeoutRef.current);
    // Hide the dropdown after a delay
    setTimeout(() => {
      setBackdropVisibility(false);
    }, 200);
  };
  const updateBackDropVisibility = (type: string) => {
    if (type === "enter") handleMouseEnter();
    if (type === "leave") handleMouseLeave();
  };

  useEffect(() => {
    const element = elementRef.current;

    if (element) {
      const computedStyle = window.getComputedStyle(element);
      const visibility = computedStyle.getPropertyValue("visibility");
      const display = computedStyle.getPropertyValue("display");

      if (visibility === "hidden" || display === "none") {
        console.log("Element is hidden or not visible");
      } else {
        console.log("Element is visible");
        setBackdropVisibility(false);
      }
    }
  }, []);

  useEffect(() => {
    async function checkUserType() {
      let userType =
        localStorage.getItem("userType") !== undefined
          ? String(localStorage.getItem("userType"))
          : undefined;
      let username =
        localStorage.getItem("username") !== undefined
          ? String(localStorage.getItem("username"))
          : undefined;

      const user =
        localStorage.getItem("user") !== undefined
          ? String(localStorage.getItem("user"))
          : undefined;
      let getUserType = await checkByemail(String(user));
      userType = getUserType.userType;
      const accessToken =
        localStorage.getItem("access_token") !== undefined
          ? String(localStorage.getItem("access_token"))
          : undefined;
      // debugger;
      if (userType === "CaptainBee") {
        if (accessToken && accessToken !== "null" && accessToken !== "") {
          //debugger;
          let resObj = await getCaptainBeeByEmail(String(user));
          console.log("resObj", resObj);
          username = resObj?.data.Username;
        }
        setisCaptain(true);
        setLoading(false);
        if (username) {
          getCaptainBeeStatics(String(username)).then((data: any) => {
            setUserProfile(data?.data?.affiliateUserProfile?.photoIdFileurl);
            setProfileLoading(false);
          });
        }
      } else {
        setisCaptain(false);
        setLoading(false);
        getHoneyUserDetails(String(user)).then((data: any) => {
          setUserProfile(data?.data?._doc?.profilePic);
          setProfileLoading(false);
        });
      }
    }
    checkUserType();
  }, []);

  const logOutUser = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    const userType =
      localStorage.getItem("userType") !== undefined
        ? String(localStorage.getItem("userType"))
        : undefined;
    localStorage.removeItem("user"); //remove one item
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("email");
    localStorage.clear(); //clear all localstorage
    console.log(userType);

    if (userType === "CaptainBee") {
      window.location.href = "/auth/login";
    } else if (userType === "HoneyBee") {
      window.location.href = "/auth/login";
    } else {
      if (window.location.pathname.includes("trade-to-earn"))
        window.location.reload();
      else window.location.href = "/auth/login";
    }
  };

  const handleLogout = (e: any, nm: string) => {
    if (nm !== "logout") return;
    logOutUser(e);
  };

  return (
    <>
      <nav style={{ position: "fixed", top: 0, left: 0, zIndex: 10000 }}>
        <div className="wrapper">
          {isMobile ? (
            ""
          ) : (
            <div
              className="backdrop"
              style={{
                display: "block",
                opacity: backdropVisibility ? 1 : 0,
                background: theme === "dark" ? "rgba(0,0,0,0.5)" : "",
                transitionDelay: ".1s",
                height: backdropVisibility ? "100vh" : 0,
              }}
            ></div>
          )}

          <div
            style={{
              display: "flex",
              alignItems: "center",

              flex: 1,
            }}
          >
            <div className="logo" style={{ marginRight: "30px" }}>
              <a href="/">
                <img
                  src={logo}
                  alt="indexx ai logo"
                  style={{ marginTop: "-8px" }}
                />
              </a>
            </div>
            <input type="radio" name="slider" id="menu-btn" />
            <input type="radio" name="slider" id="close-btn" />
            <ul
              className="nav-links"
              style={{
                flex: 1,
              }}
            >
              <label htmlFor="close-btn" className="btn close-btn">
                <img src={CrossIconNew} alt="indexx ai cross icon" />
              </label>
              {isMobile &&
                authHeader
                  .filter((el) => el.isAuth === isAuthenticated)
                  .map((element, i) => (
                    <>
                      {element.mainTextDesktop === "Logout" ||
                      element.mainTextMob === "Logout" ? (
                        <li
                          className="main"
                          style={{
                            // marginLeft: i === 0 ? "auto" : "",
                            cursor: "pointer",
                          }}
                          // onClick={(e) =>
                          //   handleLogout(
                          //     e,
                          //     element.mainTextDesktop.toLocaleLowerCase()
                          //   )
                          // }
                        >
                          <button onClick={(e) => handleLogout(e, "logout")}>
                            Logout
                          </button>
                        </li>
                      ) : (
                        <li
                          className="main"
                          style={
                            {
                              // marginLeft: i === 0 ? "auto" : "",
                            }
                          }
                        >
                          <a
                            href={element.href}
                            onClick={(e) => handleExternalLink(e, element.href)}
                            className={`desktop-item ${
                              element.active ? "link_active" : ""
                            }`}
                          >
                            {isAuthenticated
                              ? userEmail
                              : element.mainTextDesktop}
                          </a>
                          <input type="checkbox" id={element.mainTextDesktop} />
                          {isAuthenticated ? (
                            <label
                              htmlFor={element.mainTextMob}
                              className="mobile-item"
                            >
                              {isAuthenticated
                                ? userEmail
                                : element.mainTextDesktop}
                              {element.hasMegaDrop ? " >" : ""}
                            </label>
                          ) : (
                            <a href={element.href} onClick={(e) => handleExternalLink(e, element.href)} className="mobile-item">
                              {isAuthenticated
                                ? userEmail
                                : element.mainTextDesktop}
                              {element.hasMegaDrop}
                            </a>
                          )}

                          {element.hasMegaDrop ? (
                            <div
                              className="mega-box"
                              style={{
                                background:
                                  theme?.palette?.mode === "light"
                                    ? "#FAFAFC"
                                    : "",
                                color:
                                  theme?.palette?.mode === "light"
                                    ? "#333336 !important"
                                    : "",
                              }}
                              ref={elementRef}
                            >
                              <div className="content">
                                {element.dropDownContent.map((elem: any) => (
                                  <div
                                    className="row"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <header>{elem?.heading}</header>
                                    <ul
                                      className={`mega-links ${
                                        elem?.mainList ? "main" : ""
                                      }`}
                                    >
                                      {elem?.links.map((el: any) => (
                                        <li>
                                          <a
                                            onClick={(e) => {
                                              handleLogout(e, el.name.toLocaleLowerCase());
                                              handleExternalLink(e, el.href);
                                            }}
                                            href={el.href}
                                            className={
                                              theme?.palette?.mode === "light"
                                                ? "dark_color"
                                                : ""
                                            }
                                          >
                                            {el.name}
                                          </a>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                ))}

                                <div className="row"></div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </li>
                      )}
                    </>
                  ))}
              {headerData.map((element) => (
                <>
                  <li
                    className="main"
                    onMouseEnter={() =>
                      updateBackDropVisibility(
                        !element.hasMegaDrop ? "" : "enter"
                      )
                    }
                    onMouseLeave={() =>
                      updateBackDropVisibility(
                        !element.hasMegaDrop ? "" : "leave"
                      )
                    }
                  >
                    <a
                      href={element.href}
                      onClick={(e) => handleExternalLink(e, element.href)}
                      className={`desktop-item ${
                        element.active ? "link_active" : ""
                      }`}
                      onMouseEnter={() =>
                        updateBackDropVisibility(
                          !element.hasMegaDrop ? "" : "enter"
                        )
                      }
                    >
                      {element.mainTextDesktop}
                    </a>
                    {element.hasMegaDrop ? (
                      <>
                        <input type="checkbox" id={element.mainTextMob} />

                        <label
                          htmlFor={element.mainTextMob}
                          className="mobile-item"
                        >
                          {element.mainTextDesktop}{" "}
                          {element.hasMegaDrop ? ">" : ""}
                        </label>
                      </>
                    ) : (
                      <a href={element.href} onClick={(e) => handleExternalLink(e, element.href)} className="mobile-item">
                        {element.mainTextMob}
                      </a>
                    )}

                    {element.hasMegaDrop ? (
                      <div
                        className="mega-box"
                        ref={elementRef}
                        style={{
                          background: theme === "light" ? "#FAFAFC" : "",
                          color: theme === "light" ? "#333336 !important" : "",
                        }}
                      >
                        <div className="content">
                          {element.dropDownContent.map((elem) => (
                            <div
                              className="row"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <header
                                style={{
                                  color:
                                    theme === "light"
                                      ? "#A0A0A5 !important"
                                      : "",
                                }}
                              >
                                {elem.heading}
                              </header>
                              <ul
                                className={`mega-links ${
                                  elem.mainList ? "main" : ""
                                }`}
                              >
                                {elem.links.map((el) => (
                                  <li
                                    className="profile-list-item"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      textAlign: "left",
                                    }}
                                  >
                                    <a
                                      href={el.href}
                                      onClick={(e) => handleExternalLink(e, el.href)}
                                      className={
                                        theme === "light" ? "dark_color" : ""
                                      }
                                    >
                                      {el.name}
                                    </a>
                                    <div
                                      className={`profile-inner-item-border-bottom `}
                                      style={{
                                        background: "#11BE6A",
                                        width: "16px",
                                        height: "3px",
                                        marginTop: "-5px",
                                      }}
                                    ></div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))}

                          <div className="row"></div>
                          <div className="row"></div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </li>
                </>
              ))}

              {!isMobile &&
                authHeader
                  .filter((el) => el.isAuth === isAuthenticated)
                  .map((element, i) => (
                    <>
                      {element.mainTextDesktop === "Logout" ||
                      element.mainTextMob === "Logout" ? (
                        <li
                          className="main"
                          style={{
                            marginLeft: i === 0 ? "auto" : "",
                            display: "flex",
                            cursor: "pointer",
                            color: "white",
                          }}

                          // onClick={(e) =>
                          //   handleLogout(
                          //     e,
                          //     element.mainTextDesktop.toLocaleLowerCase()
                          //   )
                          // }
                        >
                          <a onClick={(e) => handleLogout(e, "logout")}>
                            Logout
                          </a>
                        </li>
                      ) : (
                        <li
                          className="main"
                          style={{
                            marginLeft: i === 0 ? "auto" : "",
                            display: "flex",
                          }}
                          // onMouseEnter={
                          //   isAuthenticated
                          //     ? () => updateBackDropVisibility("enter")
                          //     : () => updateBackDropVisibility("leave")
                          // }
                          // onMouseLeave={() => updateBackDropVisibility("leave")}
                        >
                          {!isMobile && isAuthenticated && !loading && (
                            <div
                              style={{
                                marginBottom: "-23px",
                                zIndex: "10000000",

                                // transform: "translateY(10px)",
                              }}
                            >
                              <div
                                style={{
                                  width: isCaptain ? "60px" : "50px",
                                  height: isCaptain ? "70px" : "60px",
                                  // backgroundImage: `url(${
                                  //   isCaptain ? frame : beeframe
                                  // })`,
                                  transform: !isCaptain ? "rotate(-30deg)" : "",
                                  // backgroundImage: `url(${frame})`,
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "center",
                                  position: "relative",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  alignSelf: "center",
                                  // border:"none"
                                }}
                              >
                                <div
                                  style={{
                                    width: isCaptain ? "60px" : "50px",
                                    height: isCaptain ? "70px" : "60px",
                                    position: "absolute",
                                    zIndex: "1",
                                  }}
                                >
                                  <img
                                    src={isCaptain === true ? frame : beeframe}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                    }}
                                  />
                                </div>

                                {!profileLoading && (
                                  <div
                                    className={
                                      isCaptain ? "bee-hexagon" : "elipse-img"
                                    }
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      marginBottom: `${
                                        isCaptain === true ? 0 : "7px"
                                      }`,
                                    }}
                                  >
                                    <img
                                      alt=""
                                      src={userProfile ? userProfile : dummy}
                                      width={"63px"}
                                      height={"66px"}
                                      style={{
                                        border: "none",
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          <Link
                            to={element.href}
                            className={`desktop-item ${
                              element.active ? "link_active" : ""
                            }`}
                          >
                            {isAuthenticated
                              ? userEmail
                              : element.mainTextDesktop}
                          </Link>
                          <input type="checkbox" id={element.mainTextDesktop} />

                          <a href={element.href} className="mobile-item">
                            {isAuthenticated
                              ? userEmail
                              : element.mainTextDesktop}
                          </a>

                          {element.hasMegaDrop ? (
                            <div
                              className="mega-box"
                              style={{
                                background: theme === "light" ? "#FAFAFC" : "",
                                color:
                                  theme === "light" ? "#333336 !important" : "",
                              }}
                              ref={elementRef}
                            >
                              <div className="content">
                                {element.dropDownContent.map((elem: any) => (
                                  <div
                                    className="row"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <header
                                      style={{
                                        color:
                                          theme === "light"
                                            ? "#A0A0A5 !important"
                                            : "",
                                      }}
                                    >
                                      {elem?.heading}
                                    </header>
                                    <ul
                                      className={`mega-links ${
                                        elem?.mainList ? "main" : ""
                                      }`}
                                    >
                                      {elem?.links.map((el: any) => (
                                        <li className="profile-list-item">
                                          <a
                                            onClick={(e) =>
                                              handleLogout(
                                                e,
                                                el.name.toLocaleLowerCase()
                                              )
                                            }
                                            href={el.href}
                                            className={
                                              theme === "light"
                                                ? "dark_color"
                                                : ""
                                            }
                                          >
                                            {el.name}
                                          </a>
                                          <div
                                            className={`profile-inner-item-border-bottom `}
                                            style={{
                                              background: "#11BE6A",
                                              width: "16px",
                                              height: "3px",
                                              marginTop: "-5px",
                                            }}
                                          ></div>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                ))}

                                <div className="row"></div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </li>
                      )}
                    </>
                  ))}
              {!isMobile && (
                <li
                  className="main"
                  style={{ display: "flex", alignItems: "center", marginRight: "20px" }}
                >
                  <ProductLauncher icon={zodiacLogo} theme={theme} />
                </li>
              )}
            </ul>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <DarkMode />
            <label htmlFor="menu-btn" className="btn menu-btn">
              <CrossIcon />
            </label>
          </div>
        </div>
      </nav>
    </>
  );
};

export default HeaderTest;
